import React, { FunctionComponent } from 'react';
import { FlexBox, Header, Button } from '@incodocs/style-react';

export interface NotFoundPageProps {}

export const NotFoundPage: FunctionComponent<NotFoundPageProps> = ({}) => {
  return (
    <FlexBox column>
      <Header>
        <Header.Start>
          <a href="/">
            <Button secondaryBlue>Back to Home</Button>
          </a>
        </Header.Start>
        <Header.Middle />
        <Header.End />
      </Header>
      <FlexBox flex="1" justifyContent="center" alignItems="center">
        <div className="mt--2">
          <h1 className="type--2 type--medium type--s100 type--center">
            Page Not Found.
          </h1>
          <FlexBox className="mt--2" justifyContent="center">
            <a href="/">
              <Button secondaryBlue className="mr--1">
                Back to Home
              </Button>
            </a>
          </FlexBox>
        </div>
      </FlexBox>
    </FlexBox>
  );
};

export default NotFoundPage;
